export default "/_next/static/images/how-wag-works-app-def07c1ad3d74eed9b55172130fc2441.jpg";